import { asText } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import { Hero as HeroComponent } from 'remote-com-shared/components/Hero';
import { Check } from 'remote-com-shared/components/Hero/FeaturesList';
import {
  ContentMain,
  Title,
  Description,
  Content,
  ContentLayout,
  Actions,
} from 'remote-com-shared/components/Hero/styles';
import { FormContainer } from 'remote-com-shared/components/ModalForm/styles';
import { TwoStepForm } from 'remote-com-shared/components/TwoStepForm';
import { reasonOptions } from 'remote-com-shared/data';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import styled, { css } from 'styled-components';

import { RewardsSlice } from './RewardsSlice';

import { transformProperties } from '@/src/domains/prismic/helpers';
import {
  tabletBreakpoint,
  desktopBreakpoint,
  mobileBreakpoint,
} from '@/src/domains/shared/breakpoints';
import { BadgesSection } from '@/src/views/GetStarted/GetStartedNew';
import {
  HeroDescription,
  GetStartedFeaturesList,
  GetStartedFeaturesListEntry,
  Badge,
  BadgesContainer,
  RatingStars,
} from '@/src/views/GetStarted/styles/Refreshed';
import { Header } from '@/src/views/SharedEvents/Header';

const Hero = styled(HeroComponent)`
  font-family: var(--typography-fontBrand);
  background-color: var(--colors-darkBlue);
  background-image: url(${staticAssetUrl('/images/landing/refer-friend-hero-bg.svg')});
  background-size: cover;
  background-position: center;
  overflow: hidden;
  position: relative;
  padding-top: 0;

  ${FormContainer} {
    width: 45%;

    ${desktopBreakpoint(css`
      width: 60%;
    `)}

    ${tabletBreakpoint(css`
      width: 90%;
    `)}


    ${mobileBreakpoint(css`
      width: 100%;
    `)}
  }

  ${ContentMain} {
    width: 55%;
    justify-content: center;
    display: flex;
    flex-direction: column;

    ${desktopBreakpoint(css`
      width: 40%;
    `)}

    ${tabletBreakpoint(css`
      width: 100%;
      margin: 50px 0;
    `)}
  }

  ${Title} {
    ${({ theme }) => theme.typography.scale2}
  }

  ${BadgesContainer} {
    margin-left: 0;
  }

  ${Badge} {
    min-width: 100px;
  }

  ${Description} {
    color: var(--colors-blank);
  }

  ${Content} {
    max-width: unset;
  }

  ${ContentLayout} {
    max-width: 960px;
    margin: auto;
  }

  ${Actions} {
    * + * {
      ${mobileBreakpoint(css`
        margin-top: 0;
      `)}
    }
  }
  ${RatingStars} {
    ${mobileBreakpoint(css`
      margin-top: 0;
    `)}
  }
`;

export const FeaturesListEntry = styled(GetStartedFeaturesListEntry)`
  ${Check} {
    fill: var(--colors-turquoise);
  }
`;

export function HeroSlice({ slice }) {
  const { primary, context } = transformProperties(slice);
  const { title, description, heroFormTitle, heroFormDescription, heroFormButtonLabel } = primary;

  const { hubspotFormDefinition, getStartedView, referFriendWelcomeData } = context;
  const { heroFeatures, badges, trustpilotRating } = getStartedView;

  const scheduleDemoReasonFields = reasonOptions.slice(0, 2);

  return (
    <>
      <Header />
      <Hero
        title={<PrismicRichText field={title} />}
        accessibleTitle={<PrismicRichText field={title} />}
        description={
          <HeroDescription>
            <PrismicRichText field={description} />
          </HeroDescription>
        }
        aside={
          <TwoStepForm
            formTitle={heroFormTitle || 'Start employing anywhere'}
            formDescription={
              asText(heroFormDescription) ||
              "We'll contact you to schedule a call, answer any questions you may have, and start onboarding your employees."
            }
            hubspotFormDefinition={hubspotFormDefinition}
            buttonLabel={heroFormButtonLabel}
            scheduleDemoReasonFields={scheduleDemoReasonFields}
            formID="hero-two-step-form"
            companyEmailAddressesOnly
          />
        }
        actions={
          <>
            {heroFeatures?.length > 0 && (
              <GetStartedFeaturesList>
                {heroFeatures.map(({ feature }, index) => (
                  <FeaturesListEntry key={index}>{feature}</FeaturesListEntry>
                ))}
              </GetStartedFeaturesList>
            )}
            <BadgesSection badges={badges} trustpilotRating={trustpilotRating} />
          </>
        }
      >
        <RewardsSlice data={referFriendWelcomeData} />
      </Hero>
    </>
  );
}
